import type { Driver } from "../types";
import { formatCpfMasked } from "./formatters";

export const exportDriversCsv = (drivers: Driver[]) => {
	if (!drivers || drivers.length === 0) {
		return;
	}

	const headers = [
		"Nome",
		"CPF",
		"E-mail",
		"Placa",
		"Função",
		"Numero da CNH",
		"Data de Vencimento da CNH",
		"Categoria da CNH",
	];

	const rows = drivers.map((d: Driver) => [
		d.name ?? "",
		formatCpfMasked(d.cpf ?? ""),
		d.email ?? "",
		d.vehicle?.plate ?? "",
		(d as any).function ?? "",
		(d as any).cnh ?? "",
		(d as any).cnhExpiration ?? "",
		(d as any).categoryCnh ?? "",
	]);

	const escapeCsv = (value: string) => {
		if (value.includes(";") || value.includes("\n") || value.includes('"')) {
			return `"${value.replace(/"/g, '""')}"`;
		}
		return value;
	};

	const csvContent = [headers, ...rows]
		.map((row) => row.map(escapeCsv).join(";"))
		.join("\r\n");

	const blob = new Blob([`\uFEFF${csvContent}`], {
		type: "text/csv;charset=utf-8;",
	});

	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = "motoristas.csv";
	a.click();
	URL.revokeObjectURL(url);
};
